import run from "../../animate/run";
import changeAppliedClasses from "../utils/change-applied-classes";

/**
 * Class added
 * @param {MainClassProps} main
 * @param {Array<String>} added
 * @param {Node} target
 * @param {Boolean} [external]
 */
const classadded = (main, added, target, external = false) => {
  const type = external ? "external" : "local";

  /** Loop trough all added classes in the array */
  for (const name of added) {
    /** Get available classes that are used on the element */
    const available = main.applied.get("class")?.get(type);

    if (!available) {
      continue;
    }

    changeAppliedClasses(target, name, true);

    /** Check if the added class is in the available (applied) classes */
    if (available.has(name)) {
      const triggers = available.get(name);

      for (const triggerName of triggers) {
        run(main.events.get(`classadded:${triggerName}`), "enter", true);
      }
    }
  }
};

export default classadded;
